<template>
  <div class="container">
    <img src="@/images/v2_header_with_logo.png" class="header" alt="" />

    <img src="@/images/v2_leaf_left.png" class="img-left-leaf" alt="" />
    <img src="@/images/v2_leaf_right.png" class="img-right-leaf" alt="" />
    <!-- 活动背景 -->
    <div class="activity-background-wrap">
      <div class="activity-background">{{ activityBG }}</div>
      <img
        src="@/images/v2_activity_background.png"
        class="img-activity-background-title"
        alt=""
      />
    </div>

    <!-- 活动主题 -->
    <div class="activity-theme-wrap">
      <div class="activity-theme">
        <p v-for="(item, index) in activityTheme" :key="index">{{ item }}</p>
      </div>
      <img
        src="@/images/v2_activity_theme.png"
        class="img-activity-theme-title"
        alt=""
      />
    </div>
    <!-- 活动内容 -->
    <div class="activity-content-wrap">
      <div class="activity-content">
        <!-- 一、启动发布 -->
        <img
          src="@/images/v2_title1_publish_date.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.publish_date }}</div>
        <!-- 二、征集重点 -->
        <img
          src="@/images/v2_title2_key_point.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">
          <p v-for="(item, index) in content.key_point" :key="index">
            {{ index + 1 }}.{{ item }}
          </p>
        </div>
        <!-- 三、征集时间 -->
        <img
          src="@/images/v2_title3_date.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.date }}</div>
        <!-- 四、征集形式 -->
        <img
          src="@/images/v2_title4_mode.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.mode[0] }}</div>

        <!-- 方式一 -->
        <div class="content-mode">方式一：</div>
        <div class="content-item">
          <span>{{ content.mode[1] }}</span>
          <span class="content-email">{{ content.mode[2] }}</span>
          <span>{{ content.mode[3] }}</span>
        </div>
        <div class="btn-download-wrap">
          <a
            href="http://m.aoyou.com/Resource/files/LJFLDJFDLJFDLFJHKKDJLJFS.docx"
            download="活动报名表.docx"
            v-show="!isWeChat"
            ><img
              src="@/images/v2_btn_download.png"
              class="btn_download"
              alt=""
          /></a>
          <div v-show="isWeChat" @click="download">
            <img
              src="@/images/v2_btn_download.png"
              class="btn_download"
              alt=""
            />
          </div>
          <img
            src="@/images/v2_leaf_right.png"
            class="img-right-leaf-above"
            alt=""
          />
        </div>

        <!-- 方式二 -->
        <div class="content-mode">方式二：</div>
        <div class="content-item">在线填写表格</div>

        <ao-you-form ref="aoyouForm" class="activity-form"></ao-you-form>

        <div class="btn-submit-wrap">
          <p>{{ content.agree }}</p>
          <img
            @click="submit"
            src="@/images/v2_submit.png"
            class="btn-submit"
            alt=""
            data-sensors-click
          />
        </div>
        <!-- 评审与踩线 -->
        <img
          src="@/images/v2_title5_judge.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.judge }}</div>
        <!-- 发布及推广 -->
        <img
          src="@/images/v2_title6_publish_public.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">
          <p v-for="(item, index) in content.publish_public" :key="index">
            {{ item }}
          </p>
        </div>
        <!-- 奖励及荣誉 -->
        <img
          src="@/images/v2_title7_reward_honor.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.honor }}</div>

        <!-- 星星 -->
        <img src="@/images/v2_star.png" class="img-star" alt="" />
      </div>
      <img
        src="@/images/v2_activity_content.png"
        class="img-activity-content-title"
        alt=""
      />
    </div>

    <div class="title-wrap" :style="{ opacity: opacity }" v-show="showTitle">
      <img
        src="@/images/back_black.png"
        class="back-icon"
        @click="finish"
        alt=""
      />
      <div class="title-top">{{ title }}</div>
      <img
        src="@/images/icon_share.png"
        class="share-icon"
        @click="share"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import AoYouForm from "@/components/MicroTravelForm";
import { Toast } from "mint-ui";
import { textUtils } from "@/utils/text";
import { isAndroidClient, isIOSClient, goBack } from "@/utils/hybird";
import { fetchWechatInfo } from "@/libs/wechat";
export default {
  components: {
    AoYouForm,
  },
  computed: {
    isWeChat() {
      return (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      );
    },
  },
  data() {
    return {
      activityBG: textUtils.activityBG,
      activityTheme: textUtils.activityTheme,
      content: textUtils.content,
      showTitle: false,
      title: "",
      opacity: 0,
      shareDesc: "邀请游客市民一起发现北京不一样的美",
      shareCover:
        "https://m.aoyou.com/hd/micro-travel-line/static/img/micro-travel-line-logo.jpg",
    };
  },
  created() {
    // console.log("VUE_APP_TARGET ======== "+process.env.VUE_APP_TARGET)
    // console.log(this.$route.query.showTitle)
    // console.log(this.$route);
    this.title = this.$route.meta.title;

    if (isAndroidClient() || isIOSClient()) {
      window.addEventListener("scroll", this.handleScroll, true);
      this.showTitle = true;
      //
    } else {
      // window.addEventListener("scroll", this.handleScroll, true);
      // this.showTitle = true;
    }
    // this.config();
    window.api.initShareDialog(
      document.title,
      this.shareDesc,
      location.href,
      this.shareCover
    );
  },
  methods: {
    // async config() {
    //   let result = await fetchWechatInfo();
    //   if (result.status == 200 && result.data) {
    //     let data = result.data;

    //     wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: data.AppId, // 必填，公众号的唯一标识
    //       timestamp: data.TimeStamp, // 必填，生成签名的时间戳
    //       nonceStr: data.NonceStr, // 必填，生成签名的随机串
    //       signature: data.Signature, // 必填，签名
    //       jsApiList: [
    //         "updateAppMessageShareData",
    //         "updateTimelineShareData",
    //         "onMenuShareWeibo",
    //         "onMenuShareQZone",
    //       ], // 必填，需要使用的JS接口列表
    //     });
    //   }
    //   console.log(window.api)
    //   window.api.initShareDialog(document.title, '邀请游客市民一起发现北京不一样的美', location.href, 'https://m.aoyou.com/hd/micro-travel-line/static/img/micro-travel-line-logo.jpg')
    //   console.log("=================="+document.title+","+location.href)
    // },
    share() {
      window.api.openShareDialog(
        document.title,
        this.shareDesc,
        location.href,
        this.shareCover
      );
      // wx.ready(() => {
      //   this.toast("分享");
      // });
      // wx.error((res) => {
      //   Toast({
      //     message: res,
      //     position: "middle",
      //     duration: 3000,
      //   });
      // });
      // wx.checkJsApi({
      //   jsApiList: ["updateAppMessageShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      //   success: function (res) {
      //     // 以键值对的形式返回，可用的api值true，不可用为false
      //     // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      //     wx.updateAppMessageShareData({
      //       title: "标题", // 分享标题
      //       desc: "分享内容描述", // 分享描述
      //       link: "https://m.aoyou.com", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //       imgUrl:
      //         "https://img1.baidu.com/it/u=2559382884,4024052669&fm=26&fmt=auto&gp=0.jpg", // 分享图标
      //       success: function () {
      //         // 设置成功
      //         this.toast("分享成功");
      //       },
      //       fail: function (err) {
      //         this.toast(err);
      //       },
      //     });
      //     wx.showMenuItems({
      //       menuList: ['menuItem:share:qq'], // 要显示的菜单项，所有menu项见附录3
      //     });
      //   },
      //   fail: function (res) {
      //     Toast({
      //       message: "没权限",
      //       position: "bottom",
      //       duration: 3000,
      //     });
      //   },
      // });
    },
    handleScroll(e) {
      // console.log(e.target.scrollTop)
      let top = e.target.scrollTop;
      if (top < 300) {
        this.opacity = top / 300;
      } else if (this.opacity != 1) {
        this.opacity = 1;
      }
    },
    submit() {
      this.$refs.aoyouForm.submit();
    },
    download() {
      Toast({
        message: "请点击右上角3个点，选择在浏览器打开",
        position: "middle",
        duration: 3000,
      });
    },
    finish() {
      // this.$route.go(-1)
      // window.open("about:blank", "_top").close()

      if (isAndroidClient() || isIOSClient()) {
        goBack();
      } else {
      }
    },
    toast(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000,
      });
    },
  },
};
</script>

<style>
:root {
  --radius: 20px;
  --cardBg: #fff;
  --textColor: #30833d;
  --textSize: 26px;
  --lineHeight: 56px;
  --space: 2px;
  --padding: 50px;
  --margin: 30px;
}
.container {
  background-color: #d6f0ea;
  padding-bottom: 100px;
  position: relative;
  overflow-x: hidden;
}

.header {
  width: 100%;
  height: 1150px;
}

.activity-background-wrap,
.activity-theme-wrap,
.activity-content-wrap {
  position: relative;
  border-radius: var(--radius);
  background-color: var(--cardBg);
  margin: 0 var(--margin);
  display: flex;
  justify-content: center;
  box-shadow: 0px 18px 40px 0px rgba(62, 143, 82, 0.25);
  z-index: 100;
}

.activity-background,
.activity-theme,
.activity-content {
  color: var(--textColor);
  font-size: var(--textSize);
  line-height: var(--lineHeight);
  letter-spacing: var(--space);
  padding: var(--padding);
  padding-top: 110px;
  text-indent: 2em;
}

.img-activity-background-title,
.img-activity-theme-title,
.img-activity-content-title {
  width: 514px;
  height: 117px;
  position: absolute;
  top: -59px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
}

.activity-theme-wrap {
  margin-top: 120px;
}
.activity-content-wrap {
  margin-top: 115px;
}
.activity-content {
  text-indent: 0em;
  padding: 130px 20px 50px 20px;
}
.img-activity-content-item-title {
  width: 334px;
  height: 57px;
  margin-top: 50px;
}

.img-activity-content-item-title:first-child {
  margin-top: 0px;
}

.content-item {
  padding: 15px 35px 0px 35px;
}

.content-mode {
  color: var(--textColor);
  font-weight: bolder;
  padding: 0 35px;
  font-size: 30px;
}
.content-email {
  position: relative;
}
.content-email::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0px;
  right: 0px;
  background-color: #f9cb07;
  height: 7px;
}
.btn-download-wrap {
  display: flex;
  justify-content: center;
  margin-top: 70px;
  margin-bottom: 85px;
  position: relative;
}

.img-right-leaf-above {
  position: absolute;
  right: -50px;
  top: 45px;
  width: 183px;
  height: 210px;
}

.img-right-leaf {
  position: absolute;
  right: -35px;
  top: 1780px;
  width: 183px;
  height: 210px;
}

.btn_download {
  width: 289px;
  height: 77px;
}

.btn-submit-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #999;
  margin-top: 60px;
  margin-bottom: 50px;
}

.btn-submit {
  width: 289px;
  height: 77px;
  margin-top: 40px;
}

.img-star {
  width: 56px;
  height: 56px;
  position: absolute;
  right: 40px;
  top: 110px;
}

.img-left-leaf {
  position: absolute;
  left: 0px;
  top: 2550px;
  width: 214px;
  height: 236px;
  z-index: 9;
}

.activity-form {
  padding: 40px 30px 0px;
}

.title-wrap {
  height: 90px;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  z-index: 1000;
}

.back-icon {
  width: 40px;
  height: 40px;
  margin-left: 30px;
}

.title-top {
  color: #333;
  font-size: 30px;
  line-height: 90px;
}

.share-icon {
  float: right;
  width: 60px;
  height: 60px;
  display: block;
  margin-left: auto;
  margin-right: 20px;
}
</style>